import { DOCUMENT } from '@angular/common';
import { DestroyRef, Injectable, Injector, afterNextRender, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { scanScrollEdgeHosts } from './enhance-scroll-edge-host';

@Injectable({ providedIn: 'root' })
export class ScrollEdgeService {
  private readonly document = inject(DOCUMENT);
  private readonly injector = inject(Injector);
  private started = false;
  private scanQueued = false;

  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;

    const destroyRef = inject(DestroyRef);

    const scheduleScan = (): void => {
      if (this.scanQueued) {
        return;
      }
      this.scanQueued = true;
      requestAnimationFrame(() => {
        this.scanQueued = false;
        this.scan();
      });
    };

    afterNextRender(() => scheduleScan(), { injector: this.injector });

    inject(Router)
      .events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(destroyRef),
      )
      .subscribe(() => scheduleScan());

    const observer = new MutationObserver(() => scheduleScan());
    observer.observe(this.document.body, { childList: true, subtree: true });
    destroyRef.onDestroy(() => observer.disconnect());
  }

  scan(root: ParentNode = this.document.body): void {
    scanScrollEdgeHosts(root);
  }
}
